import useSWR from 'swr';
import { fetchEndpointData } from '@/utils/fetch.client';

export type OAuthProvider = 'github' | 'gitlab';

export interface OAuthAccountSummary {
  provider: OAuthProvider;
  providerUsername: string | null;
  providerEmail: string | null;
  createdAt: string;
}

interface ListOAuthAccountsResponse {
  accounts: OAuthAccountSummary[];
}

export function useOAuthAccounts() {
  const { data, mutate, isLoading, error } = useSWR('/api/v1/user/oauth-accounts', () =>
    fetchEndpointData<ListOAuthAccountsResponse>('/api/v1/user/oauth-accounts'),
  );
  return { accounts: data?.accounts ?? [], mutate, isLoading, error };
}
